import { useReducer, useMemo, createElement, createContext } from 'react';
import { a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';

const DashboardContext = /*#__PURE__*/createContext(undefined);
const getWidget = (state, id) => {
  const widget = state.widgets.find(w => w.id === id);
  if (!widget) {
    throw Error(`could not find widget with id ${id}`);
  }
  return widget;
};
const dashboardReducer = (state, action) => {
  switch (action.type) {
    case 'LAYOUT_CHANGE':
      {
        state.widgets = action.widgets;
        return _objectSpread2({}, state);
      }
    case 'LOCK_LAYOUT':
      {
        const {
          layout
        } = getWidget(state, action.id);
        layout.static = true;
        layout.isResizable = false;
        return _objectSpread2({}, state);
      }
    case 'UNLOCK_LAYOUT':
      {
        const {
          layout
        } = getWidget(state, action.id);
        layout.static = false;
        layout.isResizable = true;
        return _objectSpread2({}, state);
      }
    case 'REMOVE_LAYOUT':
      {
        state.deletedWidgets.push(getWidget(state, action.id));
        state.widgets = state.widgets.filter(w => w.id !== action.id);
        return _objectSpread2({}, state);
      }
    case 'UNDO_REMOVE_LAYOUT':
      {
        const {
          deletedWidgets
        } = state;
        if (deletedWidgets.length > 0) {
          state.widgets.push(deletedWidgets.pop());
        }
        return _objectSpread2({}, state);
      }
    case 'SET_FULLSCREEN':
      {
        state.currentFullScreen = getWidget(state, action.id);
        return _objectSpread2({}, state);
      }
    case 'REMOVE_FULLSCREEN':
      {
        state.currentFullScreen = null;
        return _objectSpread2({}, state);
      }
    default:
      {
        return state;
      }
  }
};
function DashboardContextProvider({
  children
}) {
  const [state, dispatch] = useReducer(dashboardReducer, {
    widgets: [],
    deletedWidgets: []
  });
  const value = useMemo(() => [state, dispatch], [state, dispatch]);
  return /*#__PURE__*/createElement(DashboardContext.Provider, {
    value: value
  }, children);
}

export default DashboardContextProvider;
export { DashboardContext };
